var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{attrs:{"width":"100%","height":"100%","controls":"controls","controlslist":"nodownload"}},[_c('source',{attrs:{"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }